import React, { useEffect, useState, useMemo } from "react"
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import FormValidator from "../../../../utils/FormValidator"
import isNull from "../../../../utils/NullChecking"
import { GetZipCode, ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import Loader from "../../../shared/Loader/Loader"
import Modal from 'react-bootstrap/Modal';
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import States, { BillingMethod, EDIType, LocationProRule, PaperType, RenderingProRule, DefaultBillingStatus } from "../../../../utils/Constants"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import Table from "../../Shared/Table"
import { NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import { useSelector } from "react-redux"
import { format } from "date-fns"
import DatePicker from '../../../General/DatePicker'
import handleNumericCheck from "../../../../utils/HandleNumericKeys"
import DropdownValueHandler from "../../../shared/SuperSearch/DropdownValueHandler"
import DropdownCodeHandler from "../../../shared/SuperSearch/DropdownCodeHandler"
import UpdateReduxDropDowns from "../../../shared/UpdateReduxDropDowns"
import ReactInputMask from "react-input-mask"
import { FindSecondChild } from "../../../../utils/FindMenuOption";
import AddNewInsuranceTypeCode from "../InsuranceType/AddNewInsuranceTypeCode";
import AddNewInsuranceCategory from "../InsurranceCategory/AddNewInsurranceCategory";
import SchedulerList from '../../../Scheduler/Settings/SchedulerList'
import FeeSetup from "./FeeSetup";
import FeeSetupProvider from "./FeeSetupProvider";
import InsuranceDocuments from "./InsuranceDocuments";
import SuperSearchMultiple from "../../../shared/SuperSearch/SuperSearchMultiple";
import SuperSearchMultipleClient from "../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient";
import AddNewProgramType from "./AddNewProgramType";
import Enrollment from "./Enrollment";
import { IconDisable, IconEnabled } from "../../../shared/IconsComponent/icons";
const AddNewInsurance = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance')?.IsDeleted
    let IsHomeCare = useSelector(state => state?.GeneralDropDownsReducer?.IsHomeCare)
    let IsAdultDayCare = useSelector(state => state?.GeneralDropDownsReducer?.IsAdultDayCare)
    let BillingCycleDD = [
        { value: '', display: '' },
        { value: "Daily", display: "Daily" },
        { value: "Weekly", display: "Weekly" },

    ]
    const API_URL = enumUtil.controller.General
    const { IsOpenInsurance, onClose, onDeleteInsurance, type } = { ...props }
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [activeTabContent, setactiveTabContent] = useState("add-insurance");
    const [isOpenInsuranceType, setOpenInsuranceType] = useState(false);
    const [IsOpenInsuranceCategory, setOpenInsuranceCategory] = useState(false)
    // tabs 
    const [activeTab, setActiveTab] = useState('1');
    const [is, setIs] = useState(false);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    const providersReducer = useSelector((state) => { return state?.GeneralDropDownsReducer });
    const isLive = process.env.REACT_APP_ISLIVE
    const API_URL_Integration = enumUtil.controller.Integration

    const locationsList = providersReducer?.Location?.filter((item) => {
        return item?.value !== -1;
    });

    let Enrollment_Modal = {
        ClaimEnrollmentRequired: "",
        ClaimEnrollmentStatus: "",
        EligibilityEnrollmentRequired: "",
        UseEligibilityGroupNPI: "",
        EligibilityEnrollmentStatus: "",
        ClaimStatusEnrollmentRequired: "",
        UseClaimStatusGroupNPI: "",
        ClaimStatusEnrollmentStatus: "",
        ERAEnrollmentRequired: "",
        ERAEnrollmentStatus: ""

    }
    let Insurance_Modal = {
        ShortName: '',
        TimelyFilingAlertDays: '',
        InsuranceName: '',
        InsuranceCategory: '',
        PrimaryBillingMethod: '',
        PrimaryClaimType: '',
        SecondryBillingMethod: '',
        SecondryClaimType: '',
        DefaultClaimStatus: '',
        ARDays: "",
        IsCapitated: false,
        IsCrossOver: false,
        ClaimFilingLimit: '',
        ReportLegacyProviderID: '',
        ReportCLIA: '',
        AcceptAssignment: '',
        Notes: '',
        ClaimReceiverID: '',
        ClaimPayerID: '',
        ClaimEnrollmentRequired: false,
        EligibilityReceiverID: '',
        EligibilityPayerID: '',
        EligibilityEnrollmentRequired: false,
        ClaimStatusReceiverID: '',
        ClaimStatusPayerID: '',
        ClaimStatusEnrollmentRequired: '',
        UseEligibilityGroupNPI: '',
        RenderingProviderRule: '',
        LocationRule: '',
        RendProvItem24JRule: '',
        LocationItem32ARule: '',
        LocationItem32BRule: '',
        BillingLocationItem32BRule: '',
        BillingProviderItem33B: "",
        UseClaimReceiverGroupNPI: '',
        UseClaimStatusGroupNPI: '',
        EnteredBy: "",
        EnteredDate: "",
        UpdatedBy: "",
        UpdatedDate: "",
        // Deleted: "",
        DeletedDate: "",
        DeletedNotes: "",
        InActive: "",
        InActiveDate: "",
        InActiveNotes: "",
        ProgramType: "",
        ERAPayerID: "",
        External_payer_Submission: false,
        EDIClaimAttachment: false,
        ReportSSN:true,
    }
    let InsuranceAddress_Modal = {
        ID: "0",
        AddressLine1: "",
        AddressLine2: "",
        City: "",
        State: "",
        ZipCode: "",
        ContactPersonName: "",
        ContactPhoneNumber: "",
        EmailAddress: "",
        FaxNumber: "",
        Website: ""
    }
    let PortalCredentials_Modal = {
        ID: "0",
        Provider: "",
        URL: "",
        UN: "",
        PW: "",
        PasswordExpDate: null,
    }

    let statuOption = [
        { value: "Not Started", display: "Not Started" },
        { value: "In Process", display: "In Process" },
        { value: "Completed", display: "Completed" },

    ]

    let valModal = {}
    // validation modal 
    let ValidationModal = {
        InsurranceNameVal: "",
        PrimaryBillingMethodVal: "",
        PrimaryClaimTypeVal: "",
        WebsiteVal: "",
        InsuranceTypeCodeVal: "",
        ShortNameVal: "",
        ProgramTypeVal: ""
    }
    const [mainInsuranceAddress, setmainInsuranceAddress] = useState(InsuranceAddress_Modal);
    const [mainEnrollment, setmainEnrollment] = useState(Enrollment_Modal);
    const [saveupdateEnrollment, setsaveupdateEnrollment] = useState({})
    const [InsuranceAddressSaveUpdate, setInsuranceAddressaveUpdate] = useState(InsuranceAddress_Modal);
    const [mainPortalCredentials, setmainPortalCredentials] = useState(PortalCredentials_Modal);
    const [PortalCredentialsSaveUpdate, sePortalCredentialsSaveUpdate] = useState(PortalCredentials_Modal);
    const [mainInsuranceModal, setmainInsuranceModal] = useState(Insurance_Modal);
    const [InsuranceSaveUpdateModal, setInsuranceSaveUpdateModal] = useState({})
    const [InsurranceValidationModal, setInsurranceValidationModal] = useState(ValidationModal)
    const [InsuranceID, setInsuranceID] = useState()
    const [ReceiverDropDowns, setReceiverDropDowns] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [onInsuranceSave, setOnInsuranceSave] = useState(false)
    const [ClaimTypeP, setClaimTypeP] = useState()
    const [ClaimTypeS, setClaimTypeS] = useState()

    const [searchParam, setSearchParam] = useState({ ProgramType: "", PrimaryClaimType: "" });
    const [popup, setPopup] = useState(<></>);
    const [ReportsData, setReportsData] = useState([
        {
            id: 1,
            InsuranceName: "Elder Care",
            "0-30": "32.45",
            "31-60": "32.45",
            "61-90": "32.45",
            "91-120": "32.45",
            "120+": "32.45",
        },
    ]);

    // find practice Data by id 
    let DD;
    const LoadReceiverDropDowns = async () => {

        setIsLoading(true)
        try {
            const response = await ServerRequestProtected(API_URL + "/LoadReceiverDropDowns", 'post', {});
            setIsLoading(false)
            setReceiverDropDowns(response)
            DD = response
        } catch (error) {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        }
        // ServerRequestProtected(API_URL + "/LoadReceiverDropDowns", 'post', {
        // }).then((response) => {
        // }).catch((error) => {

        // })
    }
    useEffect(() => {
        if (props.InsuranceID != null) {
            setInsuranceID(props.InsuranceID)
            setDel(true)
        } else {
            if (!onInsuranceSave) {
                setInsuranceID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
    }, [])
    const [enrollmanetcheck, setEnrollmentCheck] = useState([])
    const [ClaimReceiverRead, setClaimReceiverRead] = useState(true)
    const [EligibilityReceiverRead, setEligibilityReceiverRead] = useState(true)
    const [ClaimStatusReceiverRead, setClaimStatusReceiverRead] = useState(true)
    const [ERAReceiverRead, setERAReceiverRead] = useState(true)




    const FindByID = () => {
        if (!isNull(InsuranceID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindInsuranceByID", 'post', {
                "ID": InsuranceID,
                "TableName": enumUtil.enumAPITableName.Insurance
            }).then((response) => {
                if (IsHomeCare === 'true' || IsAdultDayCare === 'true') {
                    setSearchParam({ ProgramType: response.Insurance[0].ProgramType })
                } else {
                    setSearchParam({ PrimaryClaimType: response.Insurance[0].PrimaryClaimType })
                }

                setIs(true)
                setClaimReceiverRead(response?.Insurance?.[0]?.IsClaimsAvailable)
                setEligibilityReceiverRead(response?.Insurance?.[0]?.IsEligiblityAvailable)
                setClaimStatusReceiverRead(response?.Insurance?.[0]?.IsClaimStatusAvailable)
                setERAReceiverRead(response?.Insurance?.[0]?.IsErasAvailable)

                setIsLoading(false)
                response.Insurance.map((item) => {
                    item.AcceptAssignment = !isNull(item.AcceptAssignment) ? item.AcceptAssignment : + ""
                    item.EligibilityReceiverID = !isNull(item.EligibilityReceiverID) ? item.EligibilityReceiverID : + -1
                    item.InsuranceCategory = item.InsuranceCategory
                    item.InsuranceID = !isNull(item.InsuranceID) ? item.InsuranceID : + ""
                    item.IsCapitated = !isNull(item.IsCapitated) ? item.IsCapitated : + ""
                    item.IsCrossOver = !isNull(item.IsCrossOver) ? item.IsCrossOver : + ""
                    item.ReportCLIA = !isNull(item.ReportCLIA) ? item.ReportCLIA : + ""
                    item.ReportLegacyProviderID = !isNull(item.ReportLegacyProviderID) ? item.ReportLegacyProviderID : + ""
                    item.UseClaimStatusGroupNPI = !isNull(item.UseClaimStatusGroupNPI) ? item.UseClaimStatusGroupNPI : + ""
                    item.UseEligibilityGroupNPI = !isNull(item.UseEligibilityGroupNPI) ? item.UseEligibilityGroupNPI : + ""
                    item.ARDays = item.ARDays
                    item.ClaimFilingLimit = item.ClaimFilingLimit
                    item.ClaimReceiverID = !isNull(item.ClaimReceiverID) ? item.ClaimReceiverID : + -1
                    item.ClaimStatusReceiverID = !isNull(item.ClaimStatusReceiverID) ? item.ClaimStatusReceiverID : + -1
                    item.InsuranceCategory = DropdownCodeHandler(DD?.InsuranceCategory, item.InsuranceCategory)
                    item.InsuranceTypeCode = DropdownCodeHandler(DD?.InsuranceType, item.InsuranceTypeCode)
                    item.ClaimReceiverID = DropdownValueHandler(DD?.ClaimReceiver, item.ClaimReceiverID)
                    item.EligibilityReceiverID = DropdownValueHandler(DD?.EligibilityReceiver, item.EligibilityReceiverID)
                    item.ClaimStatusReceiverID = DropdownValueHandler(DD?.ClaimStatusReceive, item.ClaimStatusReceiverID)
                })
                if (response.Insurance.length > 0 && !isNull(response.Insurance[0].PrimaryBillingMethod)) {
                    if (response.Insurance[0].PrimaryBillingMethod === "EDI") {
                        setClaimTypeP(EDIType)
                    } else if (response.Insurance[0].PrimaryBillingMethod === "Paper") {
                        setClaimTypeP(PaperType)
                    }
                }
                if (response.Insurance.length > 0 && !isNull(response.Insurance[0].SecondryBillingMethod)) {
                    if (response.Insurance[0].SecondryBillingMethod === "EDI") {
                        setClaimTypeS(EDIType)
                    } else if (response.Insurance[0].SecondryBillingMethod === "Paper") {
                        setClaimTypeS(PaperType)
                    }
                }
                // const updatedResponse = response?.InsuranceAddress?.map(({ Deleted, ...rest }) => rest);

                // response.InsuranceAddress.map((item, index) => {
                //     item.InsuranceAddressID = item.InsuranceAddressID + ""
                //     item['ID'] = item.InsuranceAddressID + ""
                //     item.InsuranceID = item.InsuranceID + ""
                // })
                // console.log(updatedResponse,'updatedResponse');
                const updatedResponse = response.InsuranceAddress.map(({ Deleted, ...rest }) => ({
                    ...rest,
                    InsuranceAddressID: rest.InsuranceAddressID + "",
                    ID: rest.InsuranceAddressID + "", // ID ko bhi set kar diya
                    InsuranceID: rest.InsuranceID + ""
                }));

                // Updated response ko state me set karna
                setAddedAddress(updatedResponse);



                response.PortalCredentials.map((item, index) => {
                    item.InsuranceID = item.InsuranceID + ""
                    item['ID'] = item.PortalCredentialsID + ""
                    item.PortalCredentialsID = item.PortalCredentialsID + ""
                })
                // response.InsuranceAddressResponse = setInsuranceAddressaveUpdate(response.InsuranceAddressResponse);
                setmainInsuranceModal(response.Insurance[0])
                response.Insurance[0] && setmainEnrollment(response.Insurance[0])
                // response.InsuranceAddress && setAddedAddress(response.InsuranceAddress)
                response.PortalCredentials && setAddedPortal(response.PortalCredentials)
                setEnrollmentCheck(response.Insurance[0])
                // setInsuranceID(response.InsuranceID)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
        }
    }
    const handleFindByID = async () => {
        await LoadReceiverDropDowns();
        await FindByID();
    }
    useEffect(() => {
        if (InsuranceID !== 0) {
            handleFindByID()
        } else {
            LoadReceiverDropDowns()
        }
    }, [InsuranceID])
    // handle change for Practice 
    const handleInsuranceChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainInsuranceModal };
        let saveModal = { ...InsuranceSaveUpdateModal }
        if (name === "IsCapitated" || name === 'IsCrossOver' || name === 'ReportLegacyProviderID' || name === 'ReportCLIA' || name === 'AcceptAssignment'
            || name === 'ClaimEnrollmentRequired' || name === 'EligibilityEnrollmentRequired' || name === 'ClaimStatusEnrollmentRequired' || name === 'UseClaimReceiverGroupNPI'
            || name === 'UseEligibilityGroupNPI' || name === 'UseClaimStatusGroupNPI' || name === "External_payer_Submission" || name === "EDIClaimAttachment"|| name === "ReportSSN") {   
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }
        setmainInsuranceModal(modal)
        for (var property in Insurance_Modal) {
            if (name === property) {
                if (name === "IsCapitated" || name === 'IsCrossOver' || name === 'ReportLegacyProviderID' || name === 'ReportCLIA' || name === 'AcceptAssignment'
                    || name === 'ClaimEnrollmentRequired' || name === 'EligibilityEnrollmentRequired' || name === 'ClaimStatusEnrollmentRequired' || name === 'UseClaimReceiverGroupNPI'
                    || name === 'UseEligibilityGroupNPI' || name === 'UseClaimStatusGroupNPI' || name === "External_payer_Submission" || name === "EDIClaimAttachment"|| name === "ReportSSN") {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setInsuranceSaveUpdateModal(saveModal)
    }
    const handleChangeMain = (e) => {
        const { name, checked, value, type } = e.target;
        let modal = { ...mainEnrollment };
        let saveModal = { ...saveupdateEnrollment };
        if (type === "checkbox") {
            if (name === 'ClaimEnrollmentRequired') {
                if (checked === true) {
                    setIs(true)
                    modal['ClaimEnrollmentStatus'] = statuOption?.[0]?.display
                    saveModal['ClaimEnrollmentStatus'] = statuOption?.[0]?.value
                }
                else {
                    setIs(true)
                    modal['ClaimEnrollmentStatus'] = ""
                    saveModal['ClaimEnrollmentStatus'] = ""
                }
            }
            else if (name === 'EligibilityEnrollmentRequired') {
                if (checked === true) {
                    setIs(true)
                    modal['EligibilityEnrollmentStatus'] = statuOption?.[0]?.display
                    saveModal['EligibilityEnrollmentStatus'] = statuOption?.[0]?.value
                }
                else {
                    setIs(true)
                    modal['EligibilityEnrollmentStatus'] = ""
                    saveModal['EligibilityEnrollmentStatus'] = ""
                }
            }
            else if (name === 'ClaimStatusEnrollmentRequired') {
                if (checked === true) {
                    setIs(true)
                    modal['ClaimStatusEnrollmentStatus'] = statuOption?.[0]?.display
                    saveModal['ClaimStatusEnrollmentStatus'] = statuOption?.[0]?.value
                }
                else {
                    setIs(true)
                    modal['ClaimStatusEnrollmentStatus'] = ""
                    saveModal['ClaimStatusEnrollmentStatus'] = ""
                }
            }
            else if (name === 'ERAEnrollmentRequired') {
                if (checked === true) {
                    setIs(true)
                    modal['ERAEnrollmentStatus'] = statuOption?.[0]?.display
                    saveModal['ERAEnrollmentStatus'] = statuOption?.[0]?.value
                }
                else {
                    setIs(true)
                    modal['ERAEnrollmentStatus'] = ""
                    saveModal['ERAEnrollmentStatus'] = ""
                }
            }
            modal[name] = checked;
            saveModal[name] = checked;
        } else {
            modal[name] = value;
            saveModal[name] = value;
        }
        setmainEnrollment(modal);
        setsaveupdateEnrollment(saveModal);
    };
    const handleChangeDisableButton = (type) => {
        if (type === 'ClaimReceiverRead') {
            setClaimReceiverRead(true)
            setmainInsuranceModal({ ...mainInsuranceModal, IsClaimsAvailable: true })
            setInsuranceSaveUpdateModal({ ...InsuranceSaveUpdateModal, IsClaimsAvailable: 'true' })
        }
        else if (type === 'EligibilityReceiverRead') {
            setEligibilityReceiverRead(true)
            setmainInsuranceModal({ ...mainInsuranceModal, IsEligiblityAvailable: true })
            setInsuranceSaveUpdateModal({ ...InsuranceSaveUpdateModal, IsEligiblityAvailable: 'true' })
        }
        else if (type === 'ClaimStatusReceiverRead') {
            setClaimStatusReceiverRead(true)
            setmainInsuranceModal({ ...mainInsuranceModal, IsClaimStatusAvailable: true })
            setInsuranceSaveUpdateModal({ ...InsuranceSaveUpdateModal, IsClaimStatusAvailable: 'true' })
        }
        else if (type === 'ERAReceiverRead') {
            setERAReceiverRead(true)
            setmainInsuranceModal({ ...mainInsuranceModal, IsErasAvailable: true })
            setInsuranceSaveUpdateModal({ ...InsuranceSaveUpdateModal, IsErasAvailable: 'true' })
        }


    }
    const handleChangeEnableButton = (type) => {
        if (type === 'ClaimReceiverRead') {
            setClaimReceiverRead(true)
            setmainInsuranceModal({ ...mainInsuranceModal, ClaimReceiverDisable: true })
            setInsuranceSaveUpdateModal({ ...InsuranceSaveUpdateModal, ClaimReceiverDisable: "true" })
        }
        else if (type === 'EligibilityReceiverRead') {
            setEligibilityReceiverRead(true)
            setmainInsuranceModal({ ...mainInsuranceModal, EligibilityReceiverDisable: true })
            setInsuranceSaveUpdateModal({ ...InsuranceSaveUpdateModal, EligibilityReceiverDisable: "true" })
        }
        else if (type === 'ClaimStatusReceiverRead') {
            setClaimStatusReceiverRead(true)
            setmainInsuranceModal({ ...mainInsuranceModal, ClaimStatusReceiverDisable: true })
            setInsuranceSaveUpdateModal({ ...InsuranceSaveUpdateModal, ClaimStatusReceiverDisable: "true" })
        }
        else if (type === 'ERAReceiverRead') {
            setERAReceiverRead(true)
            setmainInsuranceModal({ ...mainInsuranceModal, ERADisable: true })
            setInsuranceSaveUpdateModal({ ...InsuranceSaveUpdateModal, ERADisable: "true" })
        }


    }

    const InsurranceValidation = async () => {
        let ValidationModal = {
            InsurranceNameVal: FormValidator(
                mainInsuranceModal.InsuranceName,
                enumUtil.enumValidationType.Required,
                'Insurance Name',
            ),
            PrimaryBillingMethodVal: FormValidator(
                mainInsuranceModal.PrimaryBillingMethod,
                enumUtil.enumValidationType.Required,
                'Primary Billing',
            ),
            InsuranceTypeCodeVal: FormValidator(
                mainInsuranceModal.InsuranceTypeCode,
                enumUtil.enumValidationType.Required,
                'Insurance Type Code',
            ),
            ShortNameVal: FormValidator(
                mainInsuranceModal.ShortName,
                enumUtil.enumValidationType.Required,
                'Short Name',
            ), ...(IsHomeCare === 'true' ? {
                ProgramTypeVal: FormValidator(
                    searchParam.ProgramType,
                    enumUtil.enumValidationType.Required,
                    'Program Type'
                ),
                PrimaryClaimTypeVal: FormValidator(
                    mainInsuranceModal.PrimaryClaimType,
                    enumUtil.enumValidationType.Required,
                    'Claim Type',
                ),
            } : {
                PrimaryClaimTypeVal: FormValidator(
                    searchParam.PrimaryClaimType,
                    enumUtil.enumValidationType.Required,
                    'Claim Type',
                ),
            })
        }
        await setInsurranceValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    // save practice button click 
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    const SetInsuranceName = () => {
        if (mainInsuranceModal.InsuranceName) {
            return (
                <p className="heading sm">{mainInsuranceModal.InsuranceName}</p>
            )
        } else {
            return (
                <p className="heading sm">Add New Insurance</p>
            )
        }
    }
    const CloseInsuranceType = () => {
        setOpenInsuranceType(false)
    }
    const CloseInuranceCategory = () => {
        setOpenInsuranceCategory(false)
    }
    const saveCloseInsuranceType = () => {
        setOpenInsuranceType(false);
    }
    const saveCloseInsuranceCategory = () => {
        setOpenInsuranceCategory(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Insurance} ID={InsuranceID} onClose={onDeleteInsurance} dropDown={DropDowns.Insurance} />
    }
    let InsuranceCodePopupScreen = "";
    if (isOpenInsuranceType) {
        InsuranceCodePopupScreen = <AddNewInsuranceTypeCode isOpenInsuranceType={isOpenInsuranceType} onClose={CloseInsuranceType} onDeleteDiagnosis={saveCloseInsuranceType} />;
    }
    let InsuranceCategoryPopupScreen = "";
    if (IsOpenInsuranceCategory) {
        InsuranceCategoryPopupScreen = <AddNewInsuranceCategory IsOpenInsuranceCategory={IsOpenInsuranceCategory} onClose={CloseInuranceCategory} onDeleteInuranceC={saveCloseInsuranceCategory} />;
    }
    const handleAuditModal = () => { setisOpenAudit(true) }
    const onCloseAudit = () => { setisOpenAudit(false) }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={InsuranceID + ""} TableName={enumUtil.enumAPITableName.Insurance} />
    }
    const handleChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainInsuranceModal };
        modal[name] = value
        setmainInsuranceModal(modal)
    }
    const handleChangeEnrollmentDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainEnrollment };
        modal[name] = value
        setmainEnrollment(modal)
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainInsuranceModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'State') {
                setmainInsuranceAddress({ ...mainInsuranceAddress, State: selectedData.display })
                setInsuranceAddressaveUpdate({ ...InsuranceAddressSaveUpdate, State: selectedData.value })
            }
            else if (name === 'BillingCycle') {
                // console.log("selectedData", selectedData, "name", name, "type", type);
                modal[name] = selectedData.value;
                InsuranceSaveUpdateModal['BillingCycle'] = selectedData.value;
                // setmainInsuranceModal({ ...mainInsuranceModal, BillingCycle: selectedData.display })
                // setInsuranceSaveUpdateModal({ ...InsuranceSaveUpdateModal, BillingCycle: selectedData.value })

                // InsuranceSaveUpdateModal['BillingCycle'] = selectedData.value + "";
            }
            else if (name === 'Provider') {
                setmainPortalCredentials({ ...mainPortalCredentials, Provider: selectedData.display })
                sePortalCredentialsSaveUpdate({ ...PortalCredentialsSaveUpdate, Provider: selectedData.value })
            } else if (name === 'InsuranceTypeCode') {
                modal[name] = selectedData.display
                InsuranceSaveUpdateModal[name] = selectedData.code + "";
                InsuranceSaveUpdateModal['InsuranceTypeCodeID'] = selectedData.value + "";
            } else if (name === 'InsuranceCategory') {
                modal[name] = selectedData.display
                InsuranceSaveUpdateModal[name] = selectedData.code + "";
                InsuranceSaveUpdateModal['InsuranceCategoryID'] = selectedData.value + "";
            }
            else if (name === 'ClaimEnrollmentStatus') {
                setmainEnrollment({ ...mainEnrollment, ClaimEnrollmentStatus: selectedData.display })
                setsaveupdateEnrollment({ ...saveupdateEnrollment, ClaimEnrollmentStatus: selectedData.value })
            }
            else if (name === 'EligibilityEnrollmentStatus') {
                setmainEnrollment({ ...mainEnrollment, EligibilityEnrollmentStatus: selectedData.display })
                setsaveupdateEnrollment({ ...saveupdateEnrollment, EligibilityEnrollmentStatus: selectedData.value })
            }
            else if (name === 'ClaimStatusEnrollmentStatus') {
                setmainEnrollment({ ...mainEnrollment, ClaimStatusEnrollmentStatus: selectedData.display })
                setsaveupdateEnrollment({ ...saveupdateEnrollment, ClaimStatusEnrollmentStatus: selectedData.value })
            }
            else if (name === 'ERAEnrollmentStatus') {
                setmainEnrollment({ ...mainEnrollment, ERAEnrollmentStatus: selectedData.display })
                setsaveupdateEnrollment({ ...saveupdateEnrollment, ERAEnrollmentStatus: selectedData.value })
            }
            else {
                if (name === 'PrimaryBillingMethod') {
                    if (selectedData.value === 'Paper') {
                        setClaimTypeP(PaperType)
                    } else if (selectedData.value === 'EDI') {
                        setClaimTypeP(EDIType)
                    }
                }
                else if (name === 'DefaultClaimStatus') {
                    if (selectedData.value === 'New') {
                        setClaimTypeP(PaperType)
                    }
                    else if (selectedData.value === 'InReview') {
                        setClaimTypeP(EDIType)
                    }
                    else if (selectedData.value === 'Hold') {
                        setClaimTypeP(EDIType)
                    }
                }
                else if (name === 'SecondryBillingMethod') {
                    if (selectedData.value === 'Paper') {
                        setClaimTypeS(PaperType)
                    } else if (selectedData.value === 'EDI') {
                        setClaimTypeS(EDIType)
                    }
                }
                modal[name] = selectedData.display
                InsuranceSaveUpdateModal[name] = selectedData.value + "";
            }

        } else if (type === 'server' && !isNull(selectedData)) {
        } else {
            modal[name] = ''
            InsuranceSaveUpdateModal[name] = ''
        }
        setmainInsuranceModal(modal)

        return selectedData
    }
    const handleMUltiSelectedData = (selectedDataArray, type, name) => {
        let modal = { ...mainInsuranceModal };
        // console.log("arry", selectedDataArray);
        // console.log("arry type", type);
        if (type === 'server' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);

            modal[name] = displayValues.join(', ');
            InsuranceSaveUpdateModal[name] = valueValues.join(', ');
        } else if (type === 'client' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);
            modal[name] = displayValues.join(', ');
            InsuranceSaveUpdateModal[name] = valueValues.join(', ');
        }
        else {
            modal[name] = '';
            InsuranceSaveUpdateModal[name] = '';
        }

        setmainInsuranceModal(modal);
        setInsuranceSaveUpdateModal(InsuranceSaveUpdateModal);
        return selectedDataArray;
    }
    // added address column
    let valModaladd = {}
    let ValidationModaladd = {
        ZipCodeLengthVal: "",
        ContactNumberLen: "",
        FaxNumberlen: "",
        WebsiteVal: "",
    }
    const [AddValidationModal, setAddValidationModal] = useState(ValidationModaladd)
    const [show, setShow] = useState(false);
    const [AddedAddress, setAddedAddress] = useState([])
    const [AddedPortal, setAddedPortal] = useState([])
    const columns = [
        {
            key: 'FileName',
            name: (<GridColumnHeader gridHeader={"File Name"} handleGridHeader={() => { }}
                iconName={''} headerName={'File Name'} sortIcon={true} type={'string'} colKey={'FileName'} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <button
                        className="btn btn-link p-0">
                        {row.FileName}
                    </button>
                );
            },
        },
        {
            key: 'DocumentType',
            name: (<GridColumnHeader gridHeader={"Doc. Type"} handleGridHeader={() => { }}
                iconName={''} headerName={'Doc. Type'} sortIcon={true} type={'string'} colKey={'DocumentType'} />),
            resizable: true,
        },
        {
            key: 'Title',
            name: (<GridColumnHeader gridHeader={"Title"} handleGridHeader={() => { }}
                iconName={''} headerName={'Title'} sortIcon={true} type={'string'} colKey={'Title'} />),
            resizable: true,
        },
        {
            key: 'Description',
            name: (<GridColumnHeader gridHeader={"Description"} handleGridHeader={() => { }}
                iconName={''} headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="d-flex justify-content-between align-items-center w-100" >
                            <div className='align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100'>
                                <div className='copy_icon'>{row.Description}</div>
                                <div className="icon_copy">
                                    <i className='icon-Icon-ionic-ios-copy'></i>
                                    <p class="tool_tip xsm_text text-light">Copy</p>
                                </div>
                                <p className="xsm_text copied_text" >Copied to clipboard</p>
                            </div>
                        </div>
                    </>
                )
            }
        },
        {
            key: 'Action',
            name: (<GridColumnHeader iconName={''} headerName={'Action'} sortIcon={false} />),
            resizable: true,
            renderCell({ row }) {
                return (
                    <>
                        <button className='border-0 no-width ms-2 Sdownload-btn'>
                            <i className="icon-download-svgrepo-com" />
                        </button>
                        <button className='border-0 bg-transparent'>
                            <i class="icon-Icon-awesome-eye"></i>
                        </button>
                        <button className='border-0 bg-transparent p-0'>
                            <i className="icon-delete"></i>
                        </button>
                    </>
                )
            }
        }
    ]
    const Added_Address_columns = [
        {
            key: 'AddressLine1',
            name: (<GridColumnHeader headerName={'Address Line'} type={'string'} colKey={'AddressLine1'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
        },
        {
            key: 'City',
            name: (<GridColumnHeader headerName={'City'} type={'string'} colKey={'City'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
        },
        {
            key: 'State',
            name: (<GridColumnHeader headerName={'State'} type={'string'} colKey={'State'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
        },
        {
            key: 'ContactPhoneNumber',
            name: (<GridColumnHeader headerName={'Contact Number'} type={'string'} colKey={'ContactPhoneNumber'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
        },
        {
            key: 'FaxNumber',
            name: (<GridColumnHeader headerName={'Fax'} type={'string'} colKey={'FaxNumber'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
        },
        {
            key: 'Website',
            name: (<GridColumnHeader headerName={'Website'} type={'string'} colKey={'Website'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
        },
    ]
    const Added_Portal_columns = [
        {
            key: 'Provider',
            name: (<GridColumnHeader headerName={'Provider'} type={'string'} colKey={'Provider'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
            width: 200
        },
        {
            key: 'URL',
            name: (<GridColumnHeader headerName={'URL'} type={'string'} colKey={'URL'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
            width: 200
        },
        {
            key: 'UN',
            name: (<GridColumnHeader headerName={'UN'} type={'string'} colKey={'UN'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
            width: 150
        },
        {
            key: 'PW',
            name: (<GridColumnHeader headerName={'PW'} type={'string'} colKey={'PW'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
            width: 150
        },
        {
            key: 'PasswordExpDate',
            name: (<GridColumnHeader headerName={'Password Expiry Date'} type={'string'} colKey={'PasswordExpDate'} data={AddedAddress} setData={setAddedAddress} />),
            resizable: true,
            width: 155
        },
    ]
    const AddressValidation = async () => {
        let PhoneNumber = '';
        if (!isNull(mainInsuranceAddress.ContactPhoneNumber)) {
            PhoneNumber = mainInsuranceAddress.ContactPhoneNumber.replace(/[()-\s]/g, '');
        }
        let faxNumber = '';
        if (!isNull(mainInsuranceAddress.FaxNumber)) {
            faxNumber = mainInsuranceAddress.FaxNumber.replace(/-/g, "");
        }
        let ValidationModal = {
            ZipCodeLengthVal: FormValidator(
                mainInsuranceAddress.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            ContactNumberLen: FormValidator(
                PhoneNumber,
                enumUtil.enumValidationType.Length,
                'Contact Number',
                10
            ),
            FaxNumberlen: FormValidator(
                enumUtil.enumValidationType.Length,
                'Fax Number',
                10
            ),
            WebsiteVal: FormValidator(
                mainInsuranceAddress.Website,
                enumUtil.enumValidationType.Website,
                'Website'
            ),
        }
        await setAddValidationModal(ValidationModal)
        valModaladd = ValidationModal

    }
    const handleChangeInstitutionalAddress = (e) => {
        setIs(true)
        let { name, value } = e.target;
        let modal = { ...mainInsuranceAddress };
        if (name === 'ContactPhoneNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else if (name === 'ZipCode') {
            GetZipCode(value)
                .then(data => {
                    setmainInsuranceAddress(prevState => ({ ...prevState, ...data?.main }));
                    setInsuranceAddressaveUpdate(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else {
            modal[name] = value;
        }
        setmainInsuranceAddress(modal)
        for (var property in Insurance_Modal) {
            if (name === property) {
                modal[name] = value
            }
        }
        setInsuranceAddressaveUpdate(modal)
    }
    const handleAddInstitutionalAddress = async () => {
        await AddressValidation()
        let validation = FormValidator([valModaladd], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            const allValuesEmpty = Object.values(InsuranceAddressSaveUpdate).every(value => value === '' || value === '0' || value === null);
            if (allValuesEmpty === false) {
                setAddedAddress([...AddedAddress, InsuranceAddressSaveUpdate])
                setmainInsuranceAddress(InsuranceAddress_Modal)
                setInsuranceAddressaveUpdate(InsuranceAddress_Modal)
            } else {
                NotificationHandler('Cannot add empty address', enumUtil.enumtoaster.warning)
            }
        }
    }
    const handleChangePortalCredentials = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainPortalCredentials };
        modal[name] = value
        setmainPortalCredentials(modal)
        sePortalCredentialsSaveUpdate(modal)
    }
    const handleAddPortalCredentials = () => {
        const allValuesEmpty = Object.values(PortalCredentialsSaveUpdate).every(value => value === '' || value === '0' || value === null);
        if (allValuesEmpty === false) {
            setAddedPortal([...AddedPortal, PortalCredentialsSaveUpdate])
            setmainPortalCredentials(PortalCredentials_Modal)
            sePortalCredentialsSaveUpdate(PortalCredentials_Modal)
        } else {
            NotificationHandler('Cannot add empty credentials', enumUtil.enumtoaster.warning)
        }

    }
    const handleSaveInsurance = async () => {
        await InsurranceValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            let updatedClaimInsuranceData = {};
            for (const key in saveupdateEnrollment) {
                if (saveupdateEnrollment[key] != null) {
                    updatedClaimInsuranceData[key] = saveupdateEnrollment[key] + "";
                }
            }
            InsuranceSaveUpdateModal.ProgramType = searchParam.ProgramType
            if (IsHomeCare !== 'true' || IsAdultDayCare !== 'true') {
                InsuranceSaveUpdateModal.PrimaryClaimType = searchParam.PrimaryClaimType
            }
            let Insurance = {
                TableName: enumUtil.enumAPITableName.Insurance,
                ID: InsuranceID,
                data: { ...InsuranceSaveUpdateModal, ...updatedClaimInsuranceData },
            }
            AddedAddress.map((item, index) => {
                if (!isNull(item.State)) {
                    States.filter((type) => {
                        if (type.display === item.State) {
                            item.State = type.value
                        }
                    })
                }
                if (!isNull(item.ContactPhoneNumber)) {
                    item['ContactPhoneNumber'] = item.ContactPhoneNumber.replace(/[()-\s]/g, "");
                    item.ContactPhoneNumber = item.ContactPhoneNumber.slice(0, 10);
                }
                if (!isNull(item.FaxNumber)) {
                    item['FaxNumber'] = item.FaxNumber.replace(/-/g, "");
                }
            })
            AddedPortal.map((item, index) => {
                if (!isNull(item.State)) {
                    States.filter((type) => {
                        if (type.display === item.State) {
                            item.State = type.value
                        }
                    })
                }
            })
            let InsuranceAddress = [...AddedAddress]
            let PortalCredentials = [...AddedPortal]

            let saveModal = {
                // data: { ...updatedClaimInsuranceData },
                Insurance,
                InsuranceAddress,
                PortalCredentials
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveInsurance", 'post', saveModal).then((response) => {
                setIsLoading(false)
                if (!isNull(response.id)) {
                    UpdateReduxDropDowns(InsuranceID, DropDowns.Insurance, response.id, mainInsuranceModal.InsuranceName)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    setInsuranceID(response.id)
                    setOnInsuranceSave(true)
                    onDeleteInsurance()
                }

            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        setmainPortalCredentials({ ...mainPortalCredentials, PasswordExpDate: FormatedDate })
        sePortalCredentialsSaveUpdate({ ...PortalCredentialsSaveUpdate, PasswordExpDate: FormatedDate })
    }
    const handleTabSelect = (key) => {
        setactiveTabContent(key);
    };
    const InsuranceCodeOpen = () => {
        setOpenInsuranceType(true)
    }
    const InsurancecategoryOpen = () => {
        setOpenInsuranceCategory(true)
    }
    const [isOpenProgramType, setIsOpenProgramType] = useState(false)
    const OpenProgramType = () => {
        setIsOpenProgramType(true)
    }
    const CloseProgramType = () => {
        handleFindByID()
        setIsOpenProgramType(false)
    }

    let ProgramPopup
    if (isOpenProgramType) {
        ProgramPopup = <AddNewProgramType isOpenProgramType={isOpenProgramType} OnClose={CloseProgramType} />
    }
    // useEffect(() => {
    //     console.log("activeTabContent",);
    // }, [activeTabContent])
    const returnSelectedValues = (val, options) => {
        const selectedItems = !['-1', -1, '', null, undefined].includes(val) ? val.split(', ') : [];
        const data = options.filter(item => selectedItems.includes(String(item.value)));
        return data;
    }
    const handleEditAddress = (index) => {
        let data = AddedAddress[index]
        let AddreesCopy = [...AddedAddress]
        setmainInsuranceAddress({ ...data, State: DropdownValueHandler(States, data.State) })
        setInsuranceAddressaveUpdate({ ...data })
        AddreesCopy.splice(index, 1)
        setAddedAddress(AddreesCopy)
    }
    const handleDeleteAddress = (index) => {

        let AddreesCopy = [...AddedAddress]
        AddreesCopy.splice(index, 1)
        setAddedAddress(AddreesCopy)
    }

    const handleOpenEnrollment = (payerID, enrollment) => {

        let enroll = ''
        if (mainInsuranceModal.PrimaryClaimType === '837 P') {
            enroll = '1500'
        } else if (mainInsuranceModal.PrimaryClaimType === '837 I') {
            enroll = 'ub'
        }
        if (isLive === 'true') {
            setIsLoading(true)
            ServerRequestProtected(API_URL_Integration + "/GetEnrollProvider", 'post', {
                // "Payerid":"CPHL0",
                // "Enroll":"era"
                "Payerid": payerID,
                "Enroll": enrollment === 'ClaimReceiver' ? enroll : enrollment
            })
                .then((response) => {
                    setIsLoading(false)
                    window.open(response?.result?.link?.["@url"], "_blank");
                    // setUrl(response?.result?.link?.["@url"])
                }).catch((error) => {
                    setIsLoading(false)

                })
        } else {
            NotificationHandler("Can't use in Local ", enumUtil.enumtoaster.error);
        }
    }
    const AddNewInsuranceModalBody = () => {
        return (
            <div className="row m-0 row-gap-10 mt-2 pt-1">
                <div className="col-md-4 ps-0">
                    <div className='input form-group'>
                        <label htmlFor="ShortName">Short Name<span className='req'>*</span></label>
                        <div className={InsurranceValidationModal.ShortNameVal ? 'form-group input error' : 'input form-group'}>
                            <input type="text"
                                className='form-control'
                                name="ShortName"
                                id="ShortName"
                                autoComplete="off"
                                value={mainInsuranceModal.ShortName}
                                onChange={handleInsuranceChange}
                            />
                            {InsurranceValidationModal.ShortNameVal}
                        </div>
                    </div>
                    <div className="form-group input">
                        <label htmlFor="InsuranceName">Insurance Name<span className='req'>*</span> </label>
                        <div className={InsurranceValidationModal.InsurranceNameVal ? 'form-group input error' : 'input form-group'}>
                            <input type="text"
                                className='form-control'
                                name="InsuranceName"
                                id="InsuranceName"
                                autoComplete="off"
                                value={mainInsuranceModal.InsuranceName}
                                onChange={handleInsuranceChange}
                            />
                            {InsurranceValidationModal.InsurranceNameVal}
                        </div>
                    </div>
                    <div className='input form-group'>
                        <div className="align-items-center label-head  d-flex justify-content-between mb-1">
                            <label htmlFor="">Insurance Type Code<span className='req'>*</span></label>
                            <div>
                                <button class="btn-icon-circle btn-xs" onClick={InsuranceCodeOpen}><i class="icon-plus-icon"></i></button>
                            </div>
                        </div>
                        <div className={InsurranceValidationModal.InsuranceTypeCodeVal ? 'form-group input error' : 'input form-group'}>
                            <SuperSearchList
                                type="client"
                                id='InsuranceTypeCode'
                                name='InsuranceTypeCode'
                                searchValue={mainInsuranceModal.InsuranceTypeCode}
                                data={ReceiverDropDowns?.InsuranceType ? ReceiverDropDowns.InsuranceType : []}
                                onChange={handleChangeDD}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                inputError={InsurranceValidationModal.InsuranceTypeCodeVal}
                            />
                            {InsurranceValidationModal.InsuranceTypeCodeVal}
                        </div>
                    </div>
                    {/* <div className='input form-group'>
                        <div className="align-items-center label-head d-flex justify-content-between mb-1" >
                            <label htmlFor="">Insurance Category</label>
                            <div>
                                <button class="btn-icon-circle btn-xs" onClick={InsurancecategoryOpen}><i class="icon-plus-icon"></i></button>
                            </div>
                        </div>
                        <div className="form-group input">
                            <SuperSearchList
                                type="client"
                                id='InsuranceCategory'
                                name='InsuranceCategory'
                                searchValue={mainInsuranceModal.InsuranceCategory}
                                data={ReceiverDropDowns?.InsuranceCategory ? ReceiverDropDowns.InsuranceCategory : []}
                                onChange={handleChangeDD}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div>
                    </div> */}
                    {IsHomeCare === 'true' ?
                        <div className='input form-group'>
                            <div className="align-items-center label-head  d-flex justify-content-between mb-1">
                                <label htmlFor="">Program Type <span className='req'>*</span></label>
                                <div>
                                    <button class="btn-icon-circle btn-xs" onClick={OpenProgramType}><i class="icon-plus-icon"></i></button>
                                </div>
                            </div>
                            <div className={InsurranceValidationModal.ProgramTypeVal ? 'form-group input error' : 'input form-group'}>
                                <SuperSearchMultipleClient
                                    key={`${mainInsuranceModal.ProgramType}-${ReceiverDropDowns?.ProgramType?.length}-${isOpenProgramType}`}
                                    id="ProgramType"
                                    name="ProgramType"
                                    selectedOptionsDisplay='Program Type'
                                    initialSelectedValues={returnSelectedValues(mainInsuranceModal.ProgramType, ReceiverDropDowns?.ProgramType ? ReceiverDropDowns.ProgramType : [])}
                                    searchParam={searchParam}
                                    setSearchParam={setSearchParam}
                                    options={ReceiverDropDowns?.ProgramType}
                                    sup_btn="sup_btn-Inp"
                                    sup_inp="superSearchVisitInp"
                                />
                                {InsurranceValidationModal.ProgramTypeVal}
                            </div>
                        </div>
                        : null}


                    {IsHomeCare === 'true' || IsAdultDayCare === 'true' ?
                        <div className='input form-group'>
                            <div className="align-items-center label-head  d-flex justify-content-between mb-1">
                                <label htmlFor="">Billing Cycle <span className='req'></span></label>
                            </div>
                            {/* {console.log(mainInsuranceModal.BillingCycle, 'mainInsuranceModal.BillingCycle',BillingCycleDD) } */}

                            <div className='input form-group'>
                                <SuperSearchList
                                    type="client"
                                    id='BillingCycle'
                                    name='BillingCycle'
                                    searchValue={mainInsuranceModal.BillingCycle}
                                    data={BillingCycleDD}
                                    onChange={handleChangeDD}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                />
                            </div>
                        </div>
                        : null}
                    <div className="row">
                        <div className="col-md-6 pe-0">
                            <div className="form-group input">
                                <label htmlFor="PrimaryBillingMethod">PRI Billing Method<span className='req'>*</span></label>
                                {/* {InsurranceValidationModal.InsurranceNameVal ? 'form-group input error' : 'input form-group '} */}
                                <div className={InsurranceValidationModal.PrimaryBillingMethodVal ? 'form-group input error' : 'input form-group '}>
                                    <SuperSearchList
                                        type="client"
                                        id='PrimaryBillingMethod'
                                        name='PrimaryBillingMethod'
                                        searchValue={mainInsuranceModal.PrimaryBillingMethod}
                                        data={BillingMethod}
                                        onChange={handleChangeDD}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        placeholder={false}
                                        inputError={InsurranceValidationModal.PrimaryBillingMethodVal}
                                    />
                                    {InsurranceValidationModal.PrimaryBillingMethodVal}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            {/* <div className='input form-group '> */}
                            <div className="form-group input">
                                <label htmlFor="PrimaryClaimType">Claim Type<span className='req'>*</span></label>
                                <div className={InsurranceValidationModal.PrimaryClaimTypeVal ? 'form-group input error' : 'input form-group '}>
                                    {IsHomeCare === 'true' || IsAdultDayCare === 'true' ?
                                        <SuperSearchList
                                            type="client"
                                            id='PrimaryClaimType'
                                            name='PrimaryClaimType'
                                            searchValue={mainInsuranceModal.PrimaryClaimType}
                                            data={ClaimTypeP ? ClaimTypeP : []}
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            placeholder={false}
                                            inputError={InsurranceValidationModal.PrimaryClaimTypeVal}
                                        /> :
                                        <SuperSearchMultipleClient
                                            key={`${mainInsuranceModal.PrimaryClaimType}-${ClaimTypeP?.length}-${isOpenProgramType}`}
                                            id="PrimaryClaimType"
                                            name="PrimaryClaimType"
                                            selectedOptionsDisplay='PrimaryClaimType'
                                            initialSelectedValues={returnSelectedValues(mainInsuranceModal.PrimaryClaimType, ClaimTypeP ? ClaimTypeP : [])}
                                            searchParam={searchParam}
                                            setSearchParam={setSearchParam}
                                            options={ClaimTypeP?.filter(item => !['-1', -1, ""].includes(item.value))}
                                            sup_btn="sup_btn-Inp"
                                            sup_inp="superSearchVisitInp"
                                        />
                                    }
                                    {InsurranceValidationModal.PrimaryClaimTypeVal}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 pe-0">
                            <div className='input form-group'>
                                <label htmlFor="SecondryBillingMethod">SEC Billing Method</label>
                                <SuperSearchList
                                    type="client"
                                    id='SecondryBillingMethod'
                                    name='SecondryBillingMethod'
                                    searchValue={mainInsuranceModal.SecondryBillingMethod}
                                    data={BillingMethod}
                                    onChange={handleChangeDD}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    placeholder={false}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='input form-group'>
                                <label htmlFor="SecondryClaimType">Claim Type</label>
                                <SuperSearchList
                                    type="client"
                                    id='SecondryClaimType'
                                    name='SecondryClaimType'
                                    searchValue={mainInsuranceModal.SecondryClaimType}
                                    data={ClaimTypeS ? ClaimTypeS : []}
                                    onChange={handleChangeDD}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    placeholder={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className='input form-group'>
                                <label htmlFor="ClaimFilingLimit">Claim Filing Limit</label>
                                <input type="text"
                                    className='form-control'
                                    name="ClaimFilingLimit"
                                    id="ClaimFilingLimit"
                                    autoComplete="off"
                                    value={mainInsuranceModal.ClaimFilingLimit}
                                    onKeyPress={handleNumericCheck}
                                    onChange={handleInsuranceChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='input form-group'>
                                <label htmlFor="ARDays">Alert Days</label>
                                <input type="text"
                                    className='form-control'
                                    name="TimelyFilingAlertDays"
                                    id="TimelyFilingAlertDays"
                                    autoComplete="off"
                                    value={mainInsuranceModal.TimelyFilingAlertDays}
                                    onKeyPress={handleNumericCheck}
                                    onChange={handleInsuranceChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className='input form-group'>
                                <label htmlFor="ARDays">AR Days</label>
                                <input type="text"
                                    className='form-control'
                                    name="ARDays"
                                    id="ARDays"
                                    autoComplete="off"
                                    value={mainInsuranceModal.ARDays}
                                    onKeyPress={handleNumericCheck}
                                    onChange={handleInsuranceChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group input">
                                <label htmlFor="PrimaryBillingMethod">DEF Billing Status</label>
                                {/* {InsurranceValidationModal.InsurranceNameVal ? 'form-group input error' : 'input form-group '} */}
                                <div className='input form-group '>
                                    <SuperSearchList
                                        type="client"
                                        id='DefaultClaimStatus'
                                        name='DefaultClaimStatus'
                                        searchValue={mainInsuranceModal.DefaultClaimStatus}
                                        data={DefaultBillingStatus}
                                        onChange={handleChangeDD}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        placeholder={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-baseline custom_check_box">
                        <div className="col-md-5 pe-0">
                            <div className="d-flex gap-1 align-items-center">
                                <input
                                    className="form-check-input p-0 mt-0"
                                    type="checkbox"
                                    id="IsCapitated"
                                    name="IsCapitated"
                                    autoComplete="off"
                                    checked={mainInsuranceModal.IsCapitated}
                                    onChange={(e) => handleInsuranceChange(e)}
                                />
                                <label className="form-check-label heading font-m" for="IsCapitated">
                                    Capitated
                                </label>
                            </div>
                        </div>
                        <div className="col-md-7 ps-1 pe-0 custom_check_box">
                            <div className="d-flex gap-1 align-items-center">
                                <input
                                    className="form-check-input p-0 mt-0"
                                    type="checkbox"
                                    id="IsCrossOver"
                                    name="IsCrossOver"
                                    autoComplete="off"
                                    checked={mainInsuranceModal.IsCrossOver}
                                    onChange={(e) => handleInsuranceChange(e)}
                                />
                                <label className="form-check-label heading font-m" for="IsCrossOver">
                                    Cross Over
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row my-1 check_box">
                        <div className="col-md-5 pe-0">
                            <div className="custom_check_box d-flex gap-1 align-items-center">
                                <input
                                    className="form-check-input mt-0 p-0"
                                    type="checkbox"
                                    id="ReportCLIA"
                                    name="ReportCLIA"
                                    autoComplete="off"
                                    checked={mainInsuranceModal.ReportCLIA}
                                    onChange={(e) => handleInsuranceChange(e)}
                                />
                                <label className="form-check-label heading font-m" for="ReportCLIA">
                                    Report CLIA
                                </label>
                            </div>
                        </div>
                        <div className="col-md-7 ps-1 pe-0 check_box">
                            <div className="custom_check_box d-flex gap-1 align-items-center">
                                <input
                                    className="form-check-input p-0 mt-0"
                                    type="checkbox"
                                    id="AcceptAssignment"
                                    name="AcceptAssignment"
                                    autoComplete="off"
                                    checked={mainInsuranceModal.AcceptAssignment}
                                    onChange={(e) => handleInsuranceChange(e)}
                                />
                                <label className="form-check-label heading font-m" for="AcceptAssignment">
                                    Accept Assignment
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="check_box mb-1">
                        <div className="custom_check_box d-flex gap-1 align-items-center">
                            <input
                                className="form-check-input p-0 mt-0"
                                type="checkbox"
                                id="ReportLegacyProviderID"
                                name="ReportLegacyProviderID"
                                autoComplete="off"
                                checked={mainInsuranceModal.ReportLegacyProviderID}
                                onChange={(e) => handleInsuranceChange(e)}
                            />
                            <label className="form-check-label heading font-m" for="ReportLegacyProviderID">
                                Report Legacy Provider ID
                            </label>
                        </div>
                    </div>
                     <div className="check_box mb-1">
                        <div className="custom_check_box d-flex gap-1 align-items-center">
                            <input
                                className="form-check-input p-0 mt-0"
                                type="checkbox"
                                id="ReportSSN"
                                name="ReportSSN"
                                autoComplete="off"
                                checked={mainInsuranceModal.ReportSSN}
                                onChange={(e) => handleInsuranceChange(e)}
                            />
                            <label className="form-check-label heading font-m" for="ReportSSN">
                                Report SSN
                            </label>
                        </div>
                    </div>
                    <div className='input form-group '>
                        <label htmlFor="Notes">Notes </label>
                        <input type="text"
                            className='form-control text_area'
                            name="Notes"
                            id="Notes"
                            autoComplete="off"
                            value={mainInsuranceModal.Notes}
                            onChange={handleInsuranceChange}
                        />
                    </div>
                </div>
                <div className="col-md-8 pe-0">
                    <div className="app-accordian">
                        <Accordion defaultExpanded={true}>
                            <AccordionSummary
                                aria-hidden='true'
                                id="prac1-header"
                                aria-controls="prac1-content"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <p className="heading">EDI Settings </p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="d-flex justify-content-between align-items-center">

                                    <div className='d-flex align-items-center gap-6'>
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input p-0 mt-0"
                                                id="External_payer_Submission"
                                                name="External_payer_Submission"
                                                autoComplete="off"
                                                checked={mainInsuranceModal.External_payer_Submission}
                                                onChange={(e) => handleInsuranceChange(e)}
                                            />
                                        </div>
                                        <p className='text font-m'>External/Payer Portal Submission</p>
                                    </div>

                                    <div className='d-flex align-items-center gap-6'>
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input p-0 mt-0"
                                                id="EDIClaimAttachment"
                                                name="EDIClaimAttachment"
                                                autoComplete="off"
                                                checked={mainInsuranceModal.EDIClaimAttachment}
                                                onChange={(e) => handleInsuranceChange(e)}
                                            />
                                        </div>
                                        <p className='text font-m'>EDI Claim Attachments</p>
                                    </div>
                                </div>
                                <div className={ClaimReceiverRead === false ? 'row align-items-center mt-1 disable_fields' : 'row align-items-center mt-1'} >
                                    {/* <div className={ClaimReceiverRead ? 'disable_fields' : ''}> */}
                                    <div className="col-md-4 pe-0">
                                        <div className='input form-group'>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label htmlFor="ClaimReceiverID">Claim Receiver</label>
                                                {/* <label htmlFor="ClaimReceiverID">Claim Receiver {ClaimReceiverRead ? <span className="fst-italic notsupported">~Not Supported</span> : <></>}</label> */}
                                                {ClaimReceiverRead === false ?
                                                    // <div class="app_tooltip left"> < IconDisable /><p class="tool_tip xsm_text text-light">Not Supported</p></div> 
                                                    <div class="app_tooltip left" onClick={() => handleChangeDisableButton('ClaimReceiverRead')}> < IconEnabled /><p class="tool_tip xsm_text text-light" >Enable</p></div>
                                                    :
                                                    <></>
                                                    // <div class="app_tooltip left" onClick={() => handleChangeEnableButton('ClaimReceiverRead')}> < IconDisable /></div>
                                                }
                                            </div>
                                            <SuperSearchList
                                                type="client"
                                                id='ClaimReceiverID'
                                                name='ClaimReceiverID'
                                                searchValue={mainInsuranceModal.ClaimReceiverID}
                                                data={ReceiverDropDowns?.ClaimReceiver.length > 0 ? ReceiverDropDowns.ClaimReceiver : []}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                                isReadOnly={ClaimReceiverRead === false ? true : false}
                                                disabled={ClaimReceiverRead === false ? true : false}

                                            />
                                        </div>
                                    </div>
                                    {/*  */}
                                    <div className="col-md-3">
                                        <div className='input form-group'>
                                            <label htmlFor="ClaimPayerID">Payer ID </label>
                                            <input type="text"
                                                className='form-control'
                                                name="ClaimPayerID"
                                                id="ClaimPayerID"
                                                autoComplete="off"
                                                maxLength={10}
                                                disabled={ClaimReceiverRead === false ? true : false}
                                                // onKeyPress={handleNumericCheck}
                                                value={mainInsuranceModal.ClaimPayerID}
                                                onChange={handleInsuranceChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center gap-12">
                                        <div>
                                            <label class="text font-m text-nowrap" for="mySwitch">Enrollment Required</label>
                                            <div className="insurance_radio_btn">
                                                <div class="form-check form-switch radio_button ps-1">
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        id="ClaimEnrollmentRequired"
                                                        name="ClaimEnrollmentRequired"
                                                        autoComplete="off"
                                                        disabled={ClaimReceiverRead === false ? true : false}
                                                        checked={mainEnrollment.ClaimEnrollmentRequired}
                                                        onChange={(e) => handleChangeMain(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {mainEnrollment.ClaimEnrollmentRequired ?
                                            <div className="d-flex align-items-end gap-2">
                                                <div className='input form-group ar-multiple-br'>
                                                    <label>Status</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='ClaimEnrollmentStatus'
                                                        name='ClaimEnrollmentStatus'
                                                        searchValue={mainEnrollment.ClaimEnrollmentStatus}
                                                        data={statuOption}
                                                        onChange={handleChangeEnrollmentDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                        disabled={ClaimReceiverRead === false ? true : false}
                                                        isReadOnly={ClaimReceiverRead === false ? true : false}

                                                    />
                                                </div>
                                                <div className="app_tooltip bottom mb-06-px">
                                                    {isLive === 'true' && mainInsuranceModal.ClaimPayerID ? <i className="icon-enrollment lh-10" onClick={() => handleOpenEnrollment(mainInsuranceModal.ClaimPayerID, 'ClaimReceiver')}></i> : null}
                                                    <p class="tool_tip xsm_text text-light">View Enrollment Status</p>
                                                </div>
                                            </div>
                                            : <></>}
                                    </div>
                                    {/* </div> */}
                                </div>
                                <div className={EligibilityReceiverRead === false ? ' row mt-1 align-items-center disable_fields ' : 'row mt-1 align-items-center'}>
                                    <div className="col-md-4 pe-0">
                                        <div className='input form-group'>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label htmlFor="EligibilityReceiverID">Eligibility Rec</label>
                                                {/* <label htmlFor="ClaimReceiverID">Eligibility Rec {EligibilityReceiverRead ? <span className="fst-italic notsupported">~Not Supported</span> : <></>}</label> */}

                                                {EligibilityReceiverRead === false ?
                                                    <div class="app_tooltip left" onClick={() => handleChangeDisableButton('EligibilityReceiverRead')}> < IconEnabled /><p class="tool_tip xsm_text text-light" >Enable</p></div>


                                                    :
                                                    <></>
                                                    // <div class="app_tooltip left" onClick={() => handleChangeEnableButton('EligibilityReceiverRead')}> < IconDisable /></div>

                                                }
                                            </div>
                                            <SuperSearchList
                                                type="client"
                                                id='EligibilityReceiverID'
                                                name='EligibilityReceiverID'
                                                searchValue={mainInsuranceModal.EligibilityReceiverID}
                                                data={ReceiverDropDowns?.EligibilityReceiver.length > 0 ? ReceiverDropDowns.EligibilityReceiver : []}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                isReadOnly={EligibilityReceiverRead === false ? true : false}
                                                disabled={EligibilityReceiverRead === false ? true : false}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input form-group'>
                                            <label htmlFor="EligibilityPayerID">Payer ID </label>
                                            <input type="text"
                                                className='form-control'
                                                name="EligibilityPayerID"
                                                id="EligibilityPayerID"
                                                autoComplete="off"
                                                maxLength={10}
                                                disabled={EligibilityReceiverRead === false ? true : false}
                                                value={mainInsuranceModal.EligibilityPayerID}
                                                onChange={handleInsuranceChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center gap-12">
                                        <div className="">
                                            <label class="text font-m text-nowrap" for="mySwitch">Enrollment </label>
                                            <div className=" insurance_radio_btn check_box">
                                                <div class="form-check form-switch radio_button ps-1">
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        id="EligibilityEnrollmentRequired"
                                                        name="EligibilityEnrollmentRequired"
                                                        autoComplete="off"
                                                        disabled={EligibilityReceiverRead === false ? true : false}
                                                        checked={mainEnrollment.EligibilityEnrollmentRequired}
                                                        // onChange={handleChangeMain}
                                                        onChange={(e) => handleChangeMain(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <label class="text font-m text-nowrap" for="mySwitch">Group NPI </label>
                                            <div className=" insurance_radio_btn check_box">
                                                <div class="form-check form-switch radio_button ps-1">
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        id="UseEligibilityGroupNPI"
                                                        name="UseEligibilityGroupNPI"
                                                        autoComplete="off"
                                                        disabled={EligibilityReceiverRead === false ? true : false}
                                                        checked={mainEnrollment.UseEligibilityGroupNPI}
                                                        onChange={handleChangeMain}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {mainEnrollment.EligibilityEnrollmentRequired ?
                                            <div className="d-flex align-items-end gap-2">
                                                <div className='input form-group ar-multiple-br'>
                                                    <label>Status</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='EligibilityEnrollmentStatus'
                                                        name='EligibilityEnrollmentStatus'
                                                        searchValue={mainEnrollment.EligibilityEnrollmentStatus}
                                                        data={statuOption}
                                                        onChange={handleChangeEnrollmentDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        isReadOnly={EligibilityReceiverRead === false ? true : false}
                                                        disabled={EligibilityReceiverRead === false ? true : false}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                                <div className="app_tooltip bottom mb-06-px">
                                                    {isLive === 'true' && mainInsuranceModal.EligibilityPayerID ? <i className="icon-enrollment lh-10" onClick={() => handleOpenEnrollment(mainInsuranceModal.ClaimPayerID, 'elig')}></i> : null}
                                                    <p class="tool_tip xsm_text text-light">View Enrollment Status</p>
                                                </div>
                                            </div>
                                            : <></>}

                                    </div>
                                </div>
                                <div className={ClaimStatusReceiverRead === false ? ' row mt-1 align-items-center disable_fields ' : 'row mt-1 align-items-center'}>
                                    <div className="col-md-4 pe-0">
                                        <div className='input form-group'>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label htmlFor="ClaimStatusReceiverID">Claim Status Rec</label>
                                                {/* <label className="validation_message text-nowrap" htmlFor="ClaimReceiverID">Claim Status Rec {ClaimStatusReceiverRead ? <span className="fst-italic notsupported">~Not Supported</span> : <></>}</label> */}
                                                {ClaimStatusReceiverRead === false ?
                                                    <div class="app_tooltip left" onClick={() => handleChangeDisableButton('ClaimStatusReceiverRead')}> < IconEnabled /><p class="tool_tip xsm_text text-light" >Enable</p></div>

                                                    :
                                                    <></>
                                                    // <div class="app_tooltip left" onClick={() => handleChangeEnableButton('ClaimStatusReceiverRead')}> < IconDisable /></div>

                                                }
                                            </div>
                                            <SuperSearchList
                                                type="client"
                                                id='ClaimStatusReceiverID'
                                                name='ClaimStatusReceiverID'
                                                searchValue={mainInsuranceModal.ClaimStatusReceiverID}
                                                data={ReceiverDropDowns?.ClaimStatusReceive.length > 0 ? ReceiverDropDowns.ClaimStatusReceive : ''}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                isReadOnly={ClaimStatusReceiverRead === false ? true : false}
                                                disabled={ClaimStatusReceiverRead === false ? true : false}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input form-group'>
                                            <label htmlFor="ClaimStatusPayerID">Payer ID </label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="ClaimStatusPayerID"
                                                id="ClaimStatusPayerID"
                                                autoComplete="off"
                                                disabled={ClaimStatusReceiverRead === false ? true : false}
                                                maxLength={10}
                                                value={mainInsuranceModal.ClaimStatusPayerID}
                                                onChange={handleInsuranceChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center gap-12">
                                        <div className="">
                                            <label class="text font-m text-nowrap" for="mySwitch">Enrollment </label>

                                            <div className=" insurance_radio_btn check_box">
                                                <div class="form-check form-switch radio_button">
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        id="ClaimStatusEnrollmentRequired"
                                                        name="ClaimStatusEnrollmentRequired"
                                                        autoComplete="off"
                                                        disabled={ClaimStatusReceiverRead === false ? true : false}

                                                        checked={mainEnrollment.ClaimStatusEnrollmentRequired}
                                                        onChange={handleChangeMain}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <label class="text font-m text-nowrap" for="mySwitch">Group NPI  </label>
                                            <div className=" insurance_radio_btn check_box">
                                                <div class="form-check form-switch radio_button">
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        id="UseClaimStatusGroupNPI"
                                                        name="UseClaimStatusGroupNPI"
                                                        autoComplete="off"
                                                        disabled={ClaimStatusReceiverRead === false ? true : false}
                                                        checked={mainEnrollment.UseClaimStatusGroupNPI}
                                                        onChange={handleChangeMain}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {mainEnrollment.ClaimStatusEnrollmentRequired ?
                                            <div className="d-flex align-items-end gap-2">
                                                <div className='input form-group ar-multiple-br'>
                                                    <label>Status</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='ClaimStatusEnrollmentStatus'
                                                        name='ClaimStatusEnrollmentStatus'
                                                        searchValue={mainEnrollment.ClaimStatusEnrollmentStatus}
                                                        data={statuOption}
                                                        onChange={handleChangeEnrollmentDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        isReadOnly={ClaimStatusReceiverRead === false ? true : false}
                                                        disabled={ClaimStatusReceiverRead == false ? true : false}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                                <div className="app_tooltip bottom mb-06-px">
                                                    {isLive === 'true' && mainInsuranceModal.ClaimStatusPayerID ? <i className="icon-enrollment lh-10" onClick={() => handleOpenEnrollment(mainInsuranceModal.ClaimPayerID, 'claimstatus')}></i> : null}
                                                    <p class="tool_tip xsm_text text-light">View Enrollment Status</p>
                                                </div>
                                            </div>
                                            : <></>}

                                    </div>
                                </div>
                                <div className={ERAReceiverRead === false ? ' row align-items-center disable_fields ' : 'row align-items-center'}>
                                    <div className="col-md-4 pe-0">
                                        <div className='input form-group'>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label htmlFor="ClaimReceiverID">ERA/835</label>

                                                {/* <label htmlFor="ClaimReceiverID">ERA/835 {ERAReceiverRead ? <span className="fst-italic notsupported">~Not Supported</span> : <></>}</label> */}
                                                {ERAReceiverRead === false ?
                                                    <div class="app_tooltip left" onClick={() => handleChangeDisableButton('ERAReceiverRead')}> < IconEnabled /><p class="tool_tip xsm_text text-light" >Enable</p></div>
                                                    // <div class="app_tooltip left"> < IconDisable /><p class="tool_tip xsm_text text-light">Not Supported</p></div>
                                                    :
                                                    <></>
                                                    // <div class="app_tooltip left" onClick={() => handleChangeEnableButton('ERAReceiverRead')}> < IconDisable /></div>

                                                }

                                            </div>

                                            <SuperSearchList
                                                type="client"
                                                id='ClaimReceiverID'
                                                name='ClaimReceiverID'
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                isReadOnly={true}
                                                disabled={true}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input form-group'>
                                            <label htmlFor="ClaimPayerID">Payer ID </label>
                                            <input type="text"
                                                className='form-control'
                                                name="ERAPayerID"
                                                id="ERAPayerID"
                                                autoComplete="off"
                                                disabled={ERAReceiverRead === false ? true : false}
                                                maxLength={10}
                                                value={mainInsuranceModal.ERAPayerID}
                                                onChange={handleInsuranceChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-5 d-flex align-items-center gap-12">
                                        <div>
                                            <label class="text font-m text-nowrap" for="mySwitch">Enrollment Required</label>
                                            <div className="insurance_radio_btn">
                                                <div class="form-check form-switch radio_button ps-1">
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        id="ERAEnrollmentRequired"
                                                        name="ERAEnrollmentRequired"
                                                        autoComplete="off"
                                                        disabled={ERAReceiverRead === false ? true : false}
                                                        checked={mainEnrollment.ERAEnrollmentRequired}
                                                        onChange={handleChangeMain}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {mainEnrollment.ERAEnrollmentRequired ?
                                            <div className="d-flex align-items-end gap-2">
                                                <div className='input form-group ar-multiple-br'>
                                                    <label>Status</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='ERAEnrollmentStatus'
                                                        name='ERAEnrollmentStatus'
                                                        searchValue={mainEnrollment.ERAEnrollmentStatus}
                                                        data={statuOption}
                                                        onChange={handleChangeEnrollmentDD}
                                                        getSelectedData={handleSelectedData}
                                                        isReadOnly={ERAReceiverRead === false ? true : false}
                                                        disabled={ERAReceiverRead === false ? true : false}
                                                        is={is}
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                                <div className="app_tooltip bottom mb-06-px">
                                                    {isLive === 'true' && mainInsuranceModal.ERAPayerID ? <i className="icon-enrollment lh-10" onClick={() => handleOpenEnrollment(mainInsuranceModal.ClaimPayerID, 'era')}></i> : null}
                                                    <p class="tool_tip xsm_text text-light">View Enrollment Status</p>
                                                </div>
                                            </div>
                                            : <></>}
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded={true}>
                            <AccordionSummary
                                aria-hidden='true'
                                id="prac1-header"
                                aria-controls="prac1-content"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <p className="heading">Miscellaneous Settings </p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="row align-items-center">
                                    <div className="col-md-5">
                                        <div className='input form-group'>
                                            <label htmlFor="RenderingProviderRule">Rendering Provider Rule</label>
                                            <SuperSearchList
                                                type="client"
                                                id='RenderingProviderRule'
                                                name='RenderingProviderRule'
                                                searchValue={mainInsuranceModal.RenderingProviderRule}
                                                data={RenderingProRule}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className='input form-group'>
                                            <label htmlFor="LocationRule">Location Rule</label>
                                            <SuperSearchList
                                                type="client"
                                                id='LocationRule'
                                                name='LocationRule'
                                                searchValue={mainInsuranceModal.LocationRule}
                                                data={LocationProRule}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion >
                            <AccordionSummary
                                aria-hidden='true'
                                id="prac1-header"
                                aria-controls="prac1-content"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <p className="heading">HCFA Settings  </p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="row align-items-center">
                                    <div className="col-md-4 pe-0">
                                        <div className='input form-group'>
                                            <label htmlFor="RendProvItem24JRule">Rendering Provider ID </label>
                                            <SuperSearchList
                                                type="client"
                                                id='RendProvItem24JRule'
                                                name='RendProvItem24JRule'
                                                searchValue={mainInsuranceModal.RendProvItem24JRule}
                                                data={States}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4 pe-0">
                                        <div className='input form-group'>
                                            <label htmlFor="LocationItem32ARule">Service Location NPI</label>
                                            <SuperSearchList
                                                type="client"
                                                id='LocationItem32ARule'
                                                name='LocationItem32ARule'
                                                searchValue={mainInsuranceModal.LocationItem32ARule}
                                                data={States}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className='input form-group'>
                                            <label htmlFor="LocationItem32BRule">Service Location ID </label>
                                            <SuperSearchList
                                                type="client"
                                                id='LocationItem32BRule'
                                                name='LocationItem32BRule'
                                                searchValue={mainInsuranceModal.LocationItem32BRule}
                                                data={States}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-md-4">
                                                <div className='input form-group'>
                                                    <label htmlFor="BillingLocationItem32BRule">Billing Location ID</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='BillingLocationItem32BRule'
                                                        name='BillingLocationItem32BRule'
                                                        searchValue={mainInsuranceModal.BillingLocationItem32BRule}
                                                        data={States}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div> */}
                                    <div className="col-md-4">
                                        <div className='input form-group'>
                                            <label htmlFor="BillingProviderItem33B">Billing Provider ID</label>
                                            <SuperSearchList
                                                type="client"
                                                id='BillingProviderItem33B'
                                                name='BillingProviderItem33B'
                                                searchValue={mainInsuranceModal.BillingProviderItem33B}
                                                data={States}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={true} className="insurance-inner-tabs">
                            <AccordionSummary
                                aria-hidden='true'
                                id="prac1-header"
                                className="inner__head"
                                aria-controls="prac1-content"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <NavItem>
                                    <NavLink
                                        className={activeTab === '1' && "active"}
                                        onClick={() => setActiveTab('1')}
                                    >
                                        <span className="org_add address">Addresses</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeTab === '2' && "active"}
                                        onClick={() => setActiveTab('2')}
                                    >
                                        <span className=" address">Portal Credentials</span>
                                    </NavLink>
                                </NavItem>
                            </AccordionSummary>
                            <AccordionDetails className="inner__body mt-1">
                                <TabContent activeTab={activeTab}>
                                    {/* Address */}
                                    <TabPane tabId="1">
                                        <Accordion className="mb-1">
                                            <AccordionSummary
                                                aria-hidden='true'
                                                id="prac1-header"
                                                aria-controls="prac1-content"
                                                expandIcon={<ExpandMoreIcon />}
                                            >
                                                <p className="heading">Add New Address</p>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="row align-items-end">
                                                    <div className="col-md-6">
                                                        <div className='input form-group'>
                                                            <label htmlFor="AddressLine1">Address Line </label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="AddressLine1"
                                                                id="AddressLine1"
                                                                autoComplete="off"
                                                                maxLength={55}
                                                                value={mainInsuranceAddress.AddressLine1}
                                                                onChange={handleChangeInstitutionalAddress}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='input form-group'>
                                                            <label htmlFor="City">City</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="City"
                                                                id="City"
                                                                autoComplete="off"
                                                                maxLength={30}
                                                                value={mainInsuranceAddress.City}
                                                                onChange={handleChangeInstitutionalAddress}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='input form-group'>
                                                            <label htmlFor="State">State</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='State'
                                                                name='State'
                                                                searchValue={mainInsuranceAddress.State}
                                                                data={States}
                                                                onChange={handleChangeInstitutionalAddress}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className={AddValidationModal.ZipCodeLengthVal ? 'form-group input error' : 'input form-group'}>
                                                            <label htmlFor="City">Zip Code</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="ZipCode"
                                                                id="ZipCode"
                                                                autoComplete="off"
                                                                maxLength={9}
                                                                value={mainInsuranceAddress.ZipCode}
                                                                onKeyPress={handleNumericCheck}
                                                                onChange={handleChangeInstitutionalAddress}
                                                            />
                                                            {AddValidationModal.ZipCodeLengthVal}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className={AddValidationModal.ContactNumberLen ? 'form-group input error' : 'input form-group'}>
                                                            <label htmlFor="ContactPhoneNumber">Contact number</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                placeholder="(555) 555-5555"
                                                                name="ContactPhoneNumber"
                                                                id="ContactPhoneNumber"
                                                                autoComplete="off"
                                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                                value={mainInsuranceAddress.ContactPhoneNumber}
                                                                onChange={handleChangeInstitutionalAddress}
                                                            />
                                                            {AddValidationModal.ContactNumberLen}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className={AddValidationModal.FaxNumberlen ? 'form-group input error' : 'input form-group'}>
                                                            <label htmlFor="FaxNumber">Fax</label>
                                                            <ReactInputMask
                                                                type="text"
                                                                maskChar={0}
                                                                mask='999-999-9999'
                                                                className='form-control'
                                                                name="FaxNumber"
                                                                id="FaxNumber"
                                                                autoComplete="off"
                                                                onKeyPress={handleNumericCheck}
                                                                value={mainInsuranceAddress.FaxNumber}
                                                                onChange={handleChangeInstitutionalAddress}
                                                            />
                                                            {AddValidationModal.FaxNumberlen}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className={AddValidationModal.WebsiteVal ? 'form-group input error' : 'form-group input'}>
                                                            <label htmlFor="Website">Website</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="Website"
                                                                id="Website"
                                                                autoComplete="off"
                                                                maxLength={55}
                                                                value={mainInsuranceAddress.Website}
                                                                onChange={handleChangeInstitutionalAddress}
                                                            />
                                                            {AddValidationModal.WebsiteVal}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <button className="btn btn-validate btn-xs rounded mt-2" onClick={handleAddInstitutionalAddress}>
                                                            {/* <i className="icon-Group-5719"></i> */}AddNew
                                                        </button>
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary
                                                aria-hidden='true'
                                                id="prac1-header"
                                                aria-controls="prac1-content"
                                                expandIcon={<ExpandMoreIcon />}
                                            >
                                                <p className="heading">Added Address</p>
                                            </AccordionSummary>
                                            <AccordionDetails className="address-table act-cal-nodata">
                                                {/* {isLoading ? <Loader /> : null} */}
                                                {show === false ?
                                                    <>
                                                        <div className="card-body insurance-table pt-2">
                                                            <div className="activity_card card-body p-0 bg-light-blue hk-expand-table ad-expand-table mx-0" id='serviceLine'>
                                                                <table className='w-100'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th className='heading mw-100'>Address Line</th>
                                                                            <th className='heading'>City</th>
                                                                            <th className='heading'>State</th>
                                                                            <th className='heading'>Contact Number</th>
                                                                            <th className='heading'>Fax</th>
                                                                            <th className='heading'>Website</th>
                                                                            <th className='heading'>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {AddedAddress && AddedAddress.length > 0 ?
                                                                            AddedAddress.map((item, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <td className='text'>{item.AddressLine1} </td>
                                                                                        <td>{item.City}</td>
                                                                                        <td> {item.State}</td>
                                                                                        <td>{item.ContactPhoneNumber}</td>
                                                                                        <td className='text'> {item.FaxNumber}</td>
                                                                                        <td className=''> {item.Website}</td>
                                                                                        <td className=''>
                                                                                            <div className='d-flex align-items-baseline gap-1'>
                                                                                                <i className='icon-Icon-material-edit fs-12 ar-light-color' onClick={() => handleEditAddress(index)}></i>
                                                                                                <i className='icon-delete text-danger fs-13' onClick={() => handleDeleteAddress(index)}></i>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            }) : null}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>

                                                        {/* <Table
                                                            columns={Added_Address_columns}
                                                            rows={AddedAddress}
                                                            height='100%'
                                                            // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                                                            dynamicClass='fill-grid DataGrid-Table hk-exp-table'
                                                            rowHeight={25}
                                                            Key={621}
                                                            Name={'Insurance'}
                                                            hidePagination={true}
                                                            hideColClass='hide'
                                                        /> */}
                                                    </> : null
                                                }
                                            </AccordionDetails>
                                        </Accordion>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Accordion className="mb-1">
                                            <AccordionSummary
                                                aria-hidden='true'
                                                id="prac1-header"
                                                aria-controls="prac1-content"
                                                expandIcon={<ExpandMoreIcon />}
                                            >
                                                <p className="heading">Add New Portal Credentials</p>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="row align-items-center">
                                                    <div className="col-md-6">
                                                        <div className='input form-group'>
                                                            <label htmlFor="Provider">Provider</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='Provider'
                                                                name='Provider'
                                                                searchValue={mainPortalCredentials.Provider}
                                                                data={DropDowns.Provider}
                                                                onChange={handleChangePortalCredentials}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='input form-group'>
                                                            <label htmlFor="URL">URL</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="URL"
                                                                id="URL"
                                                                autoComplete="off"
                                                                maxLength={55}
                                                                value={mainPortalCredentials.URL}
                                                                onChange={handleChangePortalCredentials}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='input form-group'>
                                                            <label htmlFor="UN">UN</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="UN"
                                                                id="UN"
                                                                autoComplete="off"
                                                                maxLength={55}
                                                                value={mainPortalCredentials.UN}
                                                                onChange={handleChangePortalCredentials}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className='input form-group'>
                                                            <label htmlFor="PW">PW</label>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="PW"
                                                                id="PW"
                                                                autoComplete="off"
                                                                value={mainPortalCredentials.PW}
                                                                onChange={handleChangePortalCredentials}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className='input form-group'>
                                                            <DatePicker
                                                                label='Password Expiry Date'
                                                                value={mainPortalCredentials.PasswordExpDate}
                                                                // maxDate={new Date()}
                                                                handleCalendarChangefunc={(e) => handleCalendarChange(e, 'PasswordExpDate')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <button className="btn btn-validate btn-xs rounded" onClick={handleAddPortalCredentials}>
                                                            {/* <i className="icon-Group-5719"></i> */}AddNew
                                                        </button>
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary
                                                aria-hidden='true'
                                                id="prac1-header"
                                                aria-controls="prac1-content"
                                                expandIcon={<ExpandMoreIcon />}
                                            >
                                                <p className="heading">Added Portal Credentials</p>
                                            </AccordionSummary>
                                            <AccordionDetails className="address-table act-cal-nodata">
                                                {/* {isLoading ? <Loader /> : null} */}
                                                {show === false ?
                                                    <Table
                                                        columns={Added_Portal_columns}
                                                        rows={AddedPortal}
                                                        height='100%'
                                                        // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                                                        dynamicClass='fill-grid DataGrid-Table hk-exp-table'
                                                        rowHeight={25}
                                                        Key={621}
                                                        Name={'Insurance'}
                                                        hidePagination={true}
                                                        hideColClass='hide'
                                                    /> : null
                                                }
                                            </AccordionDetails>
                                        </Accordion>
                                    </TabPane>
                                </TabContent>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div >
        )
    }
    const AddNewFee_SetupmodalBody = () => {
        return (
            <>
                <div className='row mt-3 ar-fee_setup'>
                    <div className="col-md-4">
                        <div className="pb-2">
                            <p className="ar-light-color text">Insurance: <span className="heading fs-14 ar-dark-color">AETNA</span></p>
                        </div>
                        <div className="pb-1">
                            <div className='input form-group'>
                                <label htmlFor="EligibilityReceiverID">Provider</label>
                                <SuperSearchList
                                    type="client"
                                    id='EligibilityReceiverID'
                                    name='EligibilityReceiverID'
                                    searchValue={mainInsuranceModal.EligibilityReceiverID}
                                    data={ReceiverDropDowns?.EligibilityReceiver.length > 0 ? ReceiverDropDowns.EligibilityReceiver : []}
                                    onChange={handleChangeDD}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                />
                            </div>
                        </div>
                        <div className="input form-group">
                            <label htmlFor="Locations" className="d-flex align-items-center">Select Location for <span className="font-m">Alex Anderson</span>: <span className="ar_count ms-1 position-static px-1 text-white w-fit-content"> 2 of 5</span></label>
                            <SchedulerList
                                ItemLists={locationsList}
                                type={"Location"}
                                placeHolder="Select locations…"
                            // getLocation={props.getLocation}
                            // handleSelectedProviders={handleSelectedProviders}
                            // view={view}
                            />
                        </div>
                        <p className="text red-text mt-1 fst-italic fs-10">Please select Providers, Locations to update the rate</p>

                    </div>
                    <div className="col-md-8">
                        <div className=" d-flex justify-content-between align-items-center select-bg-img-1 pb-1">
                            <p className="provider-header px-2 ar-dark-color heading w-fit-content">Provider: Alex Anderson</p>
                            <div className="input">
                                <select className="form-control fc-xs rounded-5" id="BillingDocumentType" name="BillingDocumentType">
                                    <option>
                                        <select>Show Recent</select>
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div className="app-accordian">
                            <Accordion defaultExpanded={true}>
                                <AccordionSummary
                                    aria-hidden='true'
                                    id="prac1-header"
                                    aria-controls="prac1-content"
                                    expandIcon={<ExpandMoreIcon />}
                                    className="px-2"
                                >
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <p className="heading d-flex align-items-center gap-1">  <i className="icon-location-v1"><i className="path1"></i><i className="path2"></i><i className="path3"></i></i> G JASON WILKS DPM , NEXTON MARC</p>
                                        <i className="icon-close fs-10"></i>
                                        {/* <i className="fs-10 icon-edit-pencil"></i> */}
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className="p-0" >
                                    <table className='fee-setup-table'>
                                        <thead>
                                            <tr>
                                                <th className='heading'>Code</th>
                                                <th className='heading'>Amount</th>
                                                <th className='heading'>Start Date</th>
                                                <th className='heading'>End Date</th>
                                                <th className='heading'></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className='text'>
                                                    8226222
                                                </td>
                                                <td>
                                                    <div className="input">
                                                        <input type="text" className='form-control'
                                                            id="PayerClaimNo"
                                                            name='PayerClaimNo'
                                                        />
                                                    </div>
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text'>
                                                    8226222
                                                </td>
                                                <td>
                                                    <div className="input">
                                                        <input type="text" className='form-control'
                                                            id="PayerClaimNo"
                                                            name='PayerClaimNo'
                                                        />
                                                    </div>
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text'>
                                                    8226222
                                                </td>
                                                <td>
                                                    <div className="input">
                                                        <input type="text" className='form-control'
                                                            id="PayerClaimNo"
                                                            name='PayerClaimNo'
                                                        />
                                                    </div>
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text'>
                                                    8226222
                                                </td>
                                                <td>
                                                    <div className="input">
                                                        <input type="text" className='form-control'
                                                            id="PayerClaimNo"
                                                            name='PayerClaimNo'
                                                        />
                                                    </div>
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text'>
                                                    8226222
                                                </td>
                                                <td>
                                                    <div className="input">
                                                        <input type="text" className='form-control'
                                                            id="PayerClaimNo"
                                                            name='PayerClaimNo'
                                                        />
                                                    </div>
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text'>
                                                    <DatePicker />
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion defaultExpanded={true}>
                                <AccordionSummary
                                    aria-hidden='true'
                                    id="prac1-header"
                                    aria-controls="prac1-content"
                                    expandIcon={<ExpandMoreIcon />}
                                    className="px-2"
                                >
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <p className="heading d-flex align-items-center gap-1">  <i className="icon-location-v1"><i className="path1"></i><i className="path2"></i><i className="path3"></i></i> G JASON WILKS DPM , NEXTON MARC</p>
                                        {/* <i className="icon-close fs-10"></i> */}
                                        <i className="fs-10 icon-edit-pencil"></i>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className="p-0" >
                                    <table className='fee-setup-table'>
                                        <thead>
                                            <tr>
                                                <th className='heading'>Code</th>
                                                <th className='heading'>Amount</th>
                                                <th className='heading'>Start Date</th>
                                                <th className='heading'>End Date</th>
                                                <th className='heading'></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion defaultExpanded={true}>
                                <AccordionSummary
                                    aria-hidden='true'
                                    id="prac1-header"
                                    aria-controls="prac1-content"
                                    expandIcon={<ExpandMoreIcon />}
                                    className="px-2"
                                >
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <p className="heading d-flex align-items-center gap-1">  <i className="icon-location-v1"><i className="path1"></i><i className="path2"></i><i className="path3"></i></i> G JASON WILKS DPM , NEXTON MARC</p>
                                        {/* <i className="icon-close fs-10"></i> */}
                                        <i className="fs-10 icon-edit-pencil"></i>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className="p-0" >
                                    <table className='fee-setup-table'>
                                        <thead>
                                            <tr>
                                                <th className='heading'>Code</th>
                                                <th className='heading'>Amount</th>
                                                <th className='heading'>Start Date</th>
                                                <th className='heading'>End Date</th>
                                                <th className='heading'></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='text w-10'>
                                                    8226222
                                                </td>
                                                <td className="text">
                                                    $25
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text'>
                                                    5/21/2024
                                                </td>
                                                <td className='text ar-toggle'>
                                                    <div class="form-check form-switch radio_button ms-0">
                                                        <input
                                                            class="form-check-input position-absolute"
                                                            type="checkbox"
                                                            id="filesView"
                                                            name="filesView"
                                                            autocomplete="on"
                                                        // checked={true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </AccordionDetails>
                            </Accordion>
                        </div>


                    </div>

                </div>

            </>
        )
    }
    // const AddNewUploadBody = () => {
    //     return (
    //         <>
    //             <div className="row hk-docFlex__content__flex m-0 ar_upload-popup">
    //                 <div className="doc-table col-md-8 px-0 doc_list ar-no-doc">
    //                     <div className="doc-table__header pb-1 pt-0 px-0">
    //                         <p className="heading fs-13">Document Lists</p>
    //                     </div>
    //                     {isLoading ? <Loader /> : null}
    //                     <Table
    //                         columns={columns}
    //                         rows={ReportsData}
    //                         height='465px'
    //                         dynamicClass='fill-grid DataGrid-Table hk-exp-table patient_doc '
    //                         rowHeight={25}
    //                         Key={21}
    //                         Name={'PatientSearch'}
    //                         hideColClass={'hide'}
    //                         hidePagination={true}
    //                     />
    //                 </div>
    //                 <div className="doc-right-col col-md-4 px-0">
    //                     <div className="upload-box">
    //                         <div className="upload-box__header">
    //                             <p className="heading">Upload Document</p>
    //                             <span className="icon-box">
    //                                 <i className="icon-upload-converted"></i>
    //                             </span>
    //                         </div>
    //                         <div className="upload-box__filePicker">

    //                             <div className="upload-box__filePicker__fileInfo mt-1 d-flex align-items-center">
    //                                 <div className="upload-box__filePicker__form w-100 px-0 d-flex flex-column gap-10 h-auto">
    //                                     <div className='upload-box__filePicker__Btn m-0 mb-1'>
    //                                         <input
    //                                             type="file"
    //                                             className="inputfile"
    //                                             id="File"
    //                                             name="File"
    //                                             accept=".png, .txt, .pdf, .tiff"
    //                                         // accept=".jpg, .pdf "
    //                                         //  accept="image/*,application/pdf,text/plain" 
    //                                         />
    //                                         <i className="icon-link"></i>
    //                                         <label htmlFor="file">Upload a File<span className='req'>*</span></label>
    //                                     </div>
    //                                     <div className='form-group input mb-0'>
    //                                         <label htmlFor="FileName">File Name <span className='req'>*</span></label>
    //                                         <input
    //                                             type="text"
    //                                             className="form-control"
    //                                             id="FileName"
    //                                             name="FileName"
    //                                         />
    //                                     </div>
    //                                     <div className='form-group input ar_palceholder mb-0'>
    //                                         <label htmlFor="Title">Title</label>
    //                                         <SuperSearchList
    //                                             type="client"
    //                                             id='DocumentTypeID'
    //                                             name='DocumentTypeID'
    //                                             sup_btn='sup_btn-Inp'
    //                                             sup_inp='superSearchVisitInp'
    //                                         />

    //                                     </div>
    //                                     <div className="input form-group mb-0">
    //                                         <label htmlFor="Description">Description</label>
    //                                         <textarea
    //                                             className="form-control doc-textarea"
    //                                             id="Description"
    //                                             name="Description"
    //                                             rows="3">
    //                                         </textarea>
    //                                     </div>
    //                                 </div>
    //                             </div>

    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //             <ModalFooter/>
    //         </>
    //     )
    // }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {InsuranceCodePopupScreen}
            {InsuranceCategoryPopupScreen}
            {popup}
            {ProgramPopup}
            {type && type === "Wizard" ?
                <div>
                    {AuditPopup}
                    {isLoading ? <Loader /> : null}
                    <div className="pb-15">
                        {AddNewInsuranceModalBody()}
                    </div>
                    <ModalFooter isSaved={onInsuranceSave ? onDeleteInsurance : onClose} handleSave={handleSaveInsurance} UpdatedDate={mainInsuranceModal.UpdatedDate} UpdatedBy={mainInsuranceModal.UpdatedBy} ID={InsuranceID} IsEditAllowed={IsEditAllowed} />
                </div> :
                <Modal show={IsOpenInsurance} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-c-lg hk-modal-v1 add_new_insurance">
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetInsuranceName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onInsuranceSave ? onDeleteInsurance : onClose} key={621} Name={'Insurance'} IsDeleteAllowed={IsDeleteAllowed} />

                        {isLoading ? <Loader /> : null}
                        <Tab.Container activeKey={activeTabContent} onSelect={handleTabSelect}>
                            <div className="content">
                                <div className="d-flex align-items-center">
                                    <Nav variant="tabs" className='card-tabss'>
                                        <Nav.Item>
                                            <Nav.Link eventKey="add-insurance"><span className="heading me-1 font-m">Insurance</span></Nav.Link>
                                        </Nav.Item>
                                        {InsuranceID > 0 ?
                                            <Nav.Item>
                                                <Nav.Link eventKey="free-setup"><span className="heading ms-3 font-m">Fee Setup</span></Nav.Link>
                                            </Nav.Item>
                                            : null}
                                        {InsuranceID > 0 ?
                                            <Nav.Item>
                                                <Nav.Link eventKey="Documents"><span className="heading ms-3 font-m upload">Documents</span></Nav.Link>
                                            </Nav.Item>
                                            : null}
                                        {/* {InsuranceID > 0 &&
                                            (enrollmanetcheck.ClaimEnrollmentRequired ||
                                                enrollmanetcheck.ClaimStatusEnrollmentRequired ||
                                                enrollmanetcheck.EligibilityEnrollmentRequired ||
                                                enrollmanetcheck.ERAEnrollmentRequired) && (
                                                <Nav.Item>
                                                    <Nav.Link eventKey="Enrollment">
                                                        <span className="heading ms-3 font-m upload">Enrollment</span>
                                                    </Nav.Link>
                                                </Nav.Item>
                                            )
                                        } */}
                                    </Nav>
                                </div>
                            </div>

                            <TabContent>
                                <TabPane eventKey="add-insurance">
                                    {activeTabContent === 'add-insurance' && AddNewInsuranceModalBody()}
                                </TabPane>
                                <TabPane eventKey="free-setup">
                                    {activeTabContent === 'free-setup' && (
                                        IsHomeCare === 'true'
                                            ? <FeeSetup InsuranceID={InsuranceID} mainInsuranceModal={mainInsuranceModal} onClose={onClose} />
                                            : <FeeSetupProvider InsuranceID={InsuranceID} mainInsuranceModal={mainInsuranceModal} onClose={onClose} />
                                    )}
                                </TabPane>
                                <TabPane eventKey="Documents">
                                    {activeTabContent === 'Documents' && <InsuranceDocuments InsuranceID={InsuranceID} />}
                                </TabPane>
                                <TabPane eventKey="Enrollment">
                                    {activeTabContent === 'Enrollment' && <Enrollment InsuranceID={InsuranceID} />}
                                </TabPane>
                            </TabContent>
                        </Tab.Container>
                    </Modal.Body>
                    {activeTabContent === 'add-insurance' ?
                        <ModalFooter isSaved={onInsuranceSave ? onDeleteInsurance : onClose} handleSave={handleSaveInsurance} UpdatedDate={mainInsuranceModal.UpdatedDate} UpdatedBy={mainInsuranceModal.UpdatedBy} ID={InsuranceID} IsEditAllowed={IsEditAllowed} />
                        : null}
                </Modal>
            }
        </React.Fragment>

    )
}

export default AddNewInsurance